export default "__VITE_ASSET__DrEgQT6x__"